import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M12 2a.75.75 0 0 1 .62.328c.522.767 1.211 1.647 1.975 2.627.756.97 1.577 2.029 2.33 3.122C18.41 10.23 19.75 12.67 19.75 15a7.75 7.75 0 0 1-15.5 0c0-2.331 1.34-4.77 2.824-6.923.754-1.093 1.575-2.151 2.331-3.122.764-.98 1.453-1.86 1.975-2.627l.056-.073A.75.75 0 0 1 12 2M8 14.25a.75.75 0 0 0-.75.75A4.75 4.75 0 0 0 12 19.75a.75.75 0 0 0 0-1.5A3.25 3.25 0 0 1 8.75 15a.75.75 0 0 0-.75-.75"
      clipRule="evenodd"
    />
  </>
);

const DropletFilled = Icon('droplet-filled', svgContents);

export default DropletFilled;
